import Vue from 'vue';
import '@/vue.js';

import OfficialAppraisalContent from '@/web/services/OfficialAppraisalContent';
import ContactButton from '@/web/services/ContactButton';
import PropertySearch from '@/web/official-appraisal/PropertySearch';

Vue.component('official-appraisal-content', OfficialAppraisalContent);
Vue.component('contact-button', ContactButton);
Vue.component('property-search', PropertySearch);

const app = new Vue({
  el: '#main-moles',
  data() {
    return {
      popupOpen: false,
    };
  },
  computed: {},
  methods: {
    togglePopup() {
      this.popupOpen = !this.popupOpen;
    },
  },
});
